import { arrayOf, bool, number, oneOf, oneOfType, shape, string } from "prop-types";

import spaceShape from "./space";

export default {
  id: number.isRequired,
  name: string,
  status: oneOf(["public", "private", "invite"]),
  updatedAt: string.isRequired,
  address: string.isRequired,
  city: string.isRequired,
  region: shape({
    name: string,
  }),
  avatar: string,
  termsOfService: shape({
    title: string,
    body: string,
    file: shape({
      name: string,
      type: string,
      size: number,
      url: string,
    }),
  }),
  announcement: shape({
    message: string.isRequired,
    internal: bool,
  }),
  commissions: arrayOf(
    shape({
      year: arrayOf(number),
      fee: string.isRequired,
    })
  ),
  incentives: arrayOf(
    shape({
      title: string.isRequired,
      percentageFee: oneOfType([number, string]),
      fixedFee: shape({
        value: number.isRequired,
        currency: string.isRequired,
      }),
      monthsFee: number,
      startDate: string,
      endDate: string,
      minSize: shape({
        value: number.isRequired,
        unit: string.isRequired,
      }),
      duration: number,
      stage: string,
      description: string,
    })
  ),
  spaces: arrayOf(shape(spaceShape)),
  pointPerson: shape({
    fname: string.isRequired,
    lname: string.isRequired,
    company: string,
    profilePictureUrl: string,
    phone: string,
    title: string,
  }),
  portfolio: shape({
    name: string.isRequired,
  }),
  rentableArea: shape({
    value: number,
    unit: string,
  }),
  onMarket: shape({
    value: number,
    unit: string,
  }),
  onMarketPct: string,
  totalBrokerCompanies: number,
  brokerCompanyNames: arrayOf(string),
  totalDeals: number,
  totalDemand: shape({
    unit: string,
    value: number,
  }),
  totalViewings: number,
  isExpanded: bool,
};
